"use strict";
import {
  MENU_CATEGORIES,
  MENU_CATEGORIES_LIST,
  NAV_CATEGORIES_MENU,
  NAV_ITEMS,
  SPECIAL_NAV_ITEMS,
} from "../consts";
import { toggleActiveMenuItem } from "../state-actions";
import NavCategoryTitle from "./NavCategoryTitle";
import NavConfigRows from "./NavConfigRows";
import NavMenuItemBtn from "./NavMenuItemBtn";
import Toggle from "./Toggle";

const NavMenu = (activeItems, lang, isAdmin) => {
  const activeHash = window.location.hash.slice(1);
  let html = "";

  MENU_CATEGORIES_LIST.forEach(category => {
    const filteredMenuItems = NAV_CATEGORIES_MENU[category].filter(
      item => isAdmin || activeItems.has(item.hash)
    );
    if (filteredMenuItems.length) {
      html += NavCategoryTitle(MENU_CATEGORIES[category], lang, activeHash);
    }
    filteredMenuItems.forEach(item => {
      html += NavMenuItemBtn(item, lang, activeHash);
    });
  });

  SPECIAL_NAV_ITEMS.forEach(item => {
    if (item === NAV_ITEMS.FAVORITES && isAdmin) {
      return;
    }
    if (item === NAV_ITEMS.FAVORITES || isAdmin || activeItems.has(item.hash)) {
      html += NavMenuItemBtn(item, lang, activeHash);
    }
  });

  return html;
};

const populateNav = (activeItems, lang, isAdmin) => {
  const innerNavElm = document.getElementById("inner-nav");
  if (isAdmin) {
    document.getElementById("nav").style.width = "189px";
  }
  innerNavElm.innerHTML = NavMenu(activeItems, lang, isAdmin);
  if (isAdmin) {
    addToggleToNavElements(activeItems);
    innerNavElm.append(NavConfigRows());
  }
};

const addToggleToNavElements = activeItems => {
  Object.values(NAV_ITEMS).forEach(item => {
    if (item !== NAV_ITEMS.SPECIALS && SPECIAL_NAV_ITEMS.includes(item)) {
      return;
    }
    const itemBtnElm = document.getElementById(`${item.hash}-btn`);
    if (itemBtnElm) {
      const onClick = () => toggleActiveMenuItem(item);
      itemBtnElm.prepend(Toggle(onClick, activeItems.has(item.hash)));
      itemBtnElm.onclick = e => {
        if (e.target.closest(".toggle")) {
          e.preventDefault();
        }
      };
    }
  });
};

export default populateNav;
